import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { agreementKeys } from './agreementKeys';

/** Refreshes detail and history, then starts the watch that picks up the posted balance. */
export function useTopUpRecordedInvalidation(
    agreementId: string | undefined,
    startWatch: (recordedAmount: string) => void,
): (recordedAmount: string) => void {
    const queryClient = useQueryClient();
    return useCallback((recordedAmount: string) => {
        if (!agreementId) return;
        void queryClient.invalidateQueries({ queryKey: agreementKeys.detail(agreementId) });
        void queryClient.invalidateQueries({ queryKey: agreementKeys.history(agreementId) });
        startWatch(recordedAmount);
    }, [queryClient, agreementId, startWatch]);
}
